<router-outlet></router-outlet>

<fc-usercentrics *ngIf="segmentEnabled"></fc-usercentrics>
